import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RaceState } from "./race.reducer";

export const selectRaceState = createFeatureSelector<RaceState>('races');

export const selectRaceList = createSelector(
    selectRaceState,
    (state: RaceState) => state.races
)

export const selectRaceLoading = createSelector(
    selectRaceState,
    (state: RaceState) => state.loading
)

export const selectRaceNumber = createSelector(
    selectRaceState,
    (state: RaceState) => state.nb
)

export const selectRaceId = createSelector(
    selectRaceState,
    (state: RaceState) => state.selectRaceId
)


export const selectRaceDetail = createSelector(
    selectRaceState,
    (state: RaceState) => state.selectedRaceDetail
)

export const selectRaceBySlug = (link: string) => createSelector(
    selectRaceState,
    (state) => {
        if (state) {
            return state.races.find(m => m.slug === link)
        }
        return null;
    }
)